import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ChartWrapper from './ChartWrapper';

const CustomBarChart = ({
    data,
    dataKey,
    nameKey,
    loading,
    title,
    color = "#8884d8",
    link
}) => {
    const chartContent = () => {
        if (loading) {
            return (
                <div className="flex justify-center items-center h-64">
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                </div>
            );
        }

        return (
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey={nameKey} />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey={dataKey} fill={color} name={title} />
                </BarChart>
            </ResponsiveContainer>
        );
    };

    return (
        <ChartWrapper
            title={title}
            link={link}
            chartData={data}
        >
            {chartContent()}
        </ChartWrapper>
    );
};

export default CustomBarChart;